import { gql } from '@apollo/client';

export const GET_ADMIN_PLAYER_SEASON_DATA = gql`
  query GetAdminPlayerSeasonData($currentSeason: Int!, $nextSeason: Int!) {
    players(where: { lastSeason: { _in: [$currentSeason, $nextSeason] } }) {
      id
      lastName
      firstName
      lastSeason
      position
      positionSecondary
    }
  }
`;
